var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196666 15.0217 0.000666667 14.5507 0 14V12C0 11.7167 0.0960001 11.4793 0.288 11.288C0.48 11.0967 0.717333 11.0007 1 11C1.28267 10.9993 1.52033 11.0953 1.713 11.288C1.90567 11.4807 2.00133 11.718 2 12V14H14V12C14 11.7167 14.096 11.4793 14.288 11.288C14.48 11.0967 14.7173 11.0007 15 11C15.2827 10.9993 15.5203 11.0953 15.713 11.288C15.9057 11.4807 16.0013 11.718 16 12V14C16 14.55 15.8043 15.021 15.413 15.413C15.0217 15.805 14.5507 16.0007 14 16H2ZM7 3.85L5.125 5.725C4.925 5.925 4.68767 6.021 4.413 6.013C4.13833 6.005 3.90067 5.90067 3.7 5.7C3.51667 5.5 3.42067 5.26667 3.412 5C3.40333 4.73334 3.49933 4.5 3.7 4.3L7.3 0.700003C7.4 0.600003 7.50833 0.529336 7.625 0.488003C7.74167 0.44667 7.86667 0.42567 8 0.425003C8.13333 0.424337 8.25833 0.445336 8.375 0.488003C8.49167 0.53067 8.6 0.601336 8.7 0.700003L12.3 4.3C12.5 4.5 12.596 4.73334 12.588 5C12.58 5.26667 12.484 5.5 12.3 5.7C12.1 5.9 11.8627 6.00434 11.588 6.013C11.3133 6.02167 11.0757 5.92567 10.875 5.725L9 3.85V11C9 11.2833 8.904 11.521 8.712 11.713C8.52 11.905 8.28267 12.0007 8 12C7.71733 11.9993 7.48 11.9033 7.288 11.712C7.096 11.5207 7 11.2833 7 11V3.85Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload-arrow.68d3b2eb19a6e9657a147781065b958c.svg";
export { ForwardRef as ReactComponent };